module.exports = __webpack_public_path__ + "img/banner3.ad9bbb33.png";